module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/error/error.component.css
// module id = ./src/app/shared/components/error/error.component.css
// module chunks = main